// These are dialog patterns that repeat. passed as dialog it gets merged so it can be customized
const baseDialogs = {
  spinner: {
    header: 'Spinner',
    body: [
      {
        element: 'plainText',
        type: 'p',
        content: 'Spinner text'
      },
      {
        element: 'spinner',
        extend: true
      }
    ],
    footer: []
  },

  warning: {
    header: 'Warning!',
    body: [
      {
        element: 'errorContent',
        extend: true
      }
    ],
    footer: [
      {
        label: 'OK',
        target: '',
        dispatcher: { name: 'closeWarning'} //, value: true }
      },
    ]
  },
};

// These are global dialogs 
const dialogs = {
  ...baseDialogs,
  // Based dialog overrides
  calculating: {
    dialog: 'spinner',
    header: 'Calculating...',
    body: [{ content: 'Calculating speaker layout...' }]
  },
  saving: {
    dialog: 'spinner',
    header: 'SAVING...',
    body: [{ content: 'Saving file to server...' }]
  },
  loading: {
    dialog: 'spinner',
    header: '',
    body: [
      {
        element: 'spinner',
        extend: true
      },
      {
        element: 'plainText',
        type: 'p',
        content: 'Loading...',
        extend: true
      }
    ],
    footer: [],
    theme: 'loading',
    width: '300px'
  },
  exporting: {
    dialog: 'spinner',
    header: 'EXPORTING...',
    body: [{ content: 'Generating PDF Content...' }]
  },

  // Other common dialogs
  oldRevision: {
    header: 'Warning!',
    body: [
      {
        element: 'valueContent',
        parameter: 'setRevision',
        content: ['Requested revision ', ' is not the latest. Which revision would you like to load?'],
        extend: true
      },
      {
        element: 'checkBox',
        className: 'ms-2',
        items: ['requested_revision', 'latest_revision'],
        extend: true,
        dispatcher: 'setRequested'
      },
    ],
    footer: [
      {
        label: 'OK',
        target: '',
        dispatcher: { name: 'setReload' },
      },
    ]
  },

  unknowRevision: {
    header: 'Warning!',
    body: [
      {
        element: 'plainText',
        type: 'p',
        content: "Requested revision doesn't exist. Would you like to load the latest revision?",
        extend: true
      },
      {
        element: 'checkBox',
        className: 'ms-2',
        extend: true,
        dispatcher: 'setIsLatest'
      },
    ],
    footer: [
      {
        label: 'OK',
        target: '',
        dispatcher: { name: 'setLoadLatest' },
      },
    ]
  },

  saveSuccesful: {
    header: 'Save succesful!',
    body: [
      {
        element: 'plainText',
        type: 'p',
        content: "Project has been saved and save parameters have been copied to the URL in your browser's address bar and the clipboard.",
        extend: true
      },
    ],
    footer: [
      {
        label: 'OK',
        target: '',
      }
    ]
  },

  resetCustomization: {
    dialog: 'warning',
    footer: [
      {
        label: 'CANCEL',
        target: '',
        dispatcher: { name: 'updateArea', value: false}
      },
      {
        label: 'OK',
        target: '',
        dispatcher: { name: 'updateArea', value: true }
      },
    ]
  },

  resetArea: {
    dialog: 'warning',
    body: [ { 
      element: 'plainText',
      type: 'p',
      content: 'Are you sure you want to reset the room? This cannot be undone.',
     }],
    footer: [
      {
        label: 'CANCEL',
        target: '',
        dispatcher: { name: 'resetArea', value: false}
      },
      {
        label: 'OK',
        target: 'area',
        dispatcher: { name: 'resetArea', value: true }
      },
    ]
  },

  deleteArea: {
      header: 'DELETE AREA',
      body: [
        {
          element: 'plainText',
          type: 'p',
          content: 'Are you sure you want to permanently delete this area?',
          extend: true
        }
      ],
      footer: [
        {
          label: 'CANCEL',
          target: '',
          dispatcher: { name: 'setAreaToUpdate', value: null }
        },
        {
          label: 'OK',
          target: 'empty',
          dispatcher: { name: 'deleteArea' }
        }
      ]
    },

  expansionMicRecommendation: {
    header: 'Expansion Microphone Recommended',
    body: [
      {
        element: 'plainText',
        type: 'p',
        content: 'The bar microphone may not fully cover this room. Would you like to add a ceiling microphone to fill the coverage gap?',
        extend: true
      },
      {
        element: 'plainText',
        type: 'p',
        content: 'Note: If using a Tree Frog or UC Compute platform, confirm it supports multiple microphone inputs before adding an expansion mic.',
        extend: true
      }
    ],
    footer: [
      {
        label: 'No thanks',
        target: '',
        dispatcher: { name: 'setExpansionMicType', value: 'none' }
      },
      {
        label: 'Add ceiling mic',
        target: '',
        dispatcher: { name: 'setExpansionMicType', value: 'ceiling' }
      }
    ]
  },

    requestQuote: {
      header: 'Request quote',
      body: [
        {
          element: 'plainText',
          type: 'p',
          content: "Fill out this form and a Biamp expert will reach out to you via phone or email. In some regions we may share your contact details and inquiry with one of our qualified third-party sales partners to follow up directly to ensure better local service.",
          extend: true,
          style: {
            fontSize: '14px',
            marginBottom: '24px',
            lineHeight: '1.5',
            fontWeight: '400',
            fontFamily: '"Open Sans", "Roboto", sans-serif'
          }
        },
        {
          element: 'quoteFormWrapper',
          extend: true
        },
      ],
      footer: [
        {
          label: 'Cancel',
          target: '',
          style: 'outlined'
        },
        {
          label: 'Submit',
          target: '',
          dispatcher: { name: 'setSubmitRequest', value: true },
          style: 'contained'
        }
      ],
      theme: 'requestQuote',
      width: '640px',
      maxHeight: '90vh'
    }
}

export default dialogs